import React, { useState } from "react";
import "./App.css";
import axios from "axios";
import FormattedDate from "./FormattedDate";
import WeatherTemperature from "./WeatherTemperature";
import WeatherIcon from "./WeatherIcon";
import WeatherForecast from "./WeatherForecast";

export default function App(props) {
  const [weatherData, setWeatherData] = useState({ ready: false });
  const [city, setCity] = useState(props.defaultCity);
  let apiKey = "ac8953c5828dcc35be83ca782e677826";

  function handleResponse(response) {
    setWeatherData({
      ready: true,
      coordinates: response.data.coord,
      temperature: response.data.main.temp,
      date: new Date(response.data.dt * 1000),
      description: response.data.weather[0].description,
      icon: response.data.weather[0].icon,
      wind: response.data.wind.speed,
      city: response.data.name,
    });
  }

  function search() {
    let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;
    axios.get(apiUrl).then(handleResponse);
  }

  function handleSubmit(event) {
    event.preventDefault();
    search(city);
  }

  function handleCityChange(event) {
    setCity(event.target.value);
  }
  function showPosition(position) {
    let lat = position.coords.latitude;
    let lon = position.coords.longitude;
    let apiurl = `https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lon}&appid=${apiKey}&units=metric`;
    axios.get(apiurl).then(handleResponse);
  }

  function getCurrentPosition(event) {
    event.preventDefault();
    navigator.geolocation.getCurrentPosition(showPosition);
  }

  if (weatherData.ready) {
    return (
      <div>
        <div className="CurrentWeather">
          <h1>How is the weather in...?</h1>
          <div className="card w-25">
            <div className="card-body">
              <p className="card-text">
                <WeatherIcon code={weatherData.icon} />
              </p>
              <span className="text-capitalize" id="weatherDescription">
                {weatherData.description}
              </span>
              <p id="wind">
                Wind speed:{" "}
                <span id="windSpeed"> {Math.round(weatherData.wind)}</span>m/s
              </p>
              <h3>
                It is currently{" "}
                <WeatherTemperature celsius={weatherData.temperature} />
                in{" "}
                <strong>
                  <span id="searchedCity">{weatherData.city}</span>
                </strong>
                .
              </h3>
              <p id="date">
                {" "}
                <em>
                  {" "}
                  <FormattedDate date={weatherData.date} />
                </em>
              </p>
            </div>
          </div>
        </div>
        <div>
          <form onSubmit={handleSubmit} id="city-form">
            <input
              className="search"
              id="enterCity"
              type="text"
              placeholder="Enter City..."
              autoFocus="on"
              onChange={handleCityChange}
            />
          </form>
          <input
            className="btn btn-primary button"
            id="button"
            type="submit"
            value="Search"
            onClick={handleSubmit}
          />
          <form id="location-form">
            <input
              className="btn btn-outline-primary button"
              id="location-button"
              type="submit"
              value="Current Location"
              onClick={getCurrentPosition}
            />
          </form>
        </div>
        <WeatherForecast coordinates={weatherData.coordinates} />
      </div>
    );
  } else {
    search();
    return "Loading...";
  }
}
